import React, { useEffect, useState } from 'react';

const GalleryPage1 = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const cardData = [
    {
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744391537/image_awqhfq.png",
      date: "March 03, 2025",
      title: "How High Presicision Farming is changing agriculture",
      description: "Smart  farming uses technology such as mobile application to improving production ",
    },
  
  ];

  return (
    <div className="relative bg-white px-4 md:px-20">
      {/* Content */}
      <div className="relative z-10   md:pt-5 pt-2">
        {/* Heading */}
        <div className="mt-4 md:mt-2 md:mb-5">
         <a href='/Gallery'>
         <h1 className="text-[10px] md:text-[36px] font-bold mt-3 text-[#FDBD26]">Gallery</h1>
        <h1 className="text-[10px] md:text-[48px] font-bold text-black">Revolutionizing Agriculture with Digital solutions</h1>
        <h1 className="text-[10px] md:text-[32px] font-normal mb-3 md:mb-2 text-black">Stay informed with insights and innovation sin Agriculture</h1>


        
         </a>
        </div>

        {/* Records Section */}
        <div className="relative w-full  overflow-hidden  rounded-lg bg-white">
        <div className="relative w-full rounded-lg">
          {isLoading && (
            <div className="absolute inset-0 flex items-center justify-center bg-gray-100 z-10">
              <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-green-950 border-solid"></div>
            </div>
          )}
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745772009/image_56_hih2ck.png"
            alt="Securing Agriculture in Namibia"
            className={`w-full md:h-[622px] object-cover   rounded-lg transition-opacity duration-500 ${isLoading ? 'opacity-0' : 'opacity-100'}`}
            onLoad={() => setIsLoading(false)}
          />
          
        </div>
      </div>
      </div>
 
      <div className='px-1'>
  {/* Content Section */}
  <div className="mt-5 max-w-screen-xl w-full">
    <h3 className="text-black font-normal text-[6px] md:text-[30px]">March 03, 2025</h3>
    <div className="flex items-center gap-6 md:gap-8 text-[6px] md:text-[30px] font-normal text-black">
      <p>Story by Editorial team</p>
      <div className="flex items-center gap-2 text-[#155528]">
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743893169/Time_progress_light_ecbt3q.png"
          alt="Clock"
          className="h-3 w-3 md:h-8 md:w-8"
        />
        <p>2 Minutes read</p>
      </div>
    </div>
  </div>

  <h3 className="text-black font-bold text-[8px] md:mt-12  mt-5 md:text-[32px] ">Stay informed with insights and innovation</h3>

  {/* Main Text Section */}
  <div className="mt-1 space-y-10">
    <p className="text-[8px] md:text-[32px] text-black font-normal">
      Revolutionizing agriculture with digital solutions refers to the use of advanced technologies, software, and data-driven tools to transform traditional farming practices into more efficient, productive, and sustainable systems. Digital solutions in agriculture integrate innovations like big data, artificial intelligence (AI), the Internet of Things (IoT), machine learning, and automation to modernize every aspect of farming, from crop production to livestock management.
      <br /><br />
      Here’s a closer look at how digital solutions are revolutionizing agriculture:
    </p>

    <p className="text-[8px] md:text-[32px] text-black font-normal">
      1. <strong className=' font-normal'>Data-Driven Decision Making</strong><br />
      <strong  className=' font-normal'>Big Data and Analytics:</strong> Farmers now have access to vast amounts of data, including weather patterns, soil conditions, and market trends. By analyzing this data, they can make informed decisions about planting, watering, fertilizing, and harvesting, improving yields and reducing  waste.<br />
      <strong  className=' font-normal'>Predictive Analytics:</strong> Advanced algorithms predict outcomes like crop yield, pest outbreaks, or weather disruptions, helping farmers take proactive steps rather than reactive ones. <br />
      2. <strong  className=' font-normal'>Precision Agriculture</strong><br />
      <strong  className=' font-normal'>GPS Technology:</strong> GPS-enabled tractors and machinery can plant seeds, apply fertilizers, and harvest crops with incredible precision, reducing waste and optimizing resource use.<br />
      <strong  className=' font-normal'>Drones and Satellites:</strong> Drones and satellite imagery help farmers monitor crop health, detect diseases, and identify nutrient deficiencies in real time, allowing for targeted interventions.<br />
      <strong  className=' font-normal'>Variable Rate Technology (VRT):</strong> VRT helps apply water, fertilizers, and pesticides only where needed in specific quantities, reducing overuse and improving crop health. <br/>
      3. <strong  className=' font-normal'>Automation and Robotics</strong><br />
      <strong  className=' font-normal'>Autonomous Machinery:</strong> Tractors, harvesters, and other farming equipment can operate autonomously, performing tasks like plowing, planting, and harvesting with little to no human intervention.<br />
      <strong  className=' font-normal'>Robotic Harvesters:</strong> Robots are being developed to pick fruits and vegetables, reducing labor costs and increasing efficiency, especially for crops that require delicate handling.<br/>
      4. <strong  className=' font-normal'>Internet of Things (IoT)</strong><br />
      <strong  className=' font-normal'>Smart Sensors:</strong> IoT devices can monitor soil moisture, temperature, livestock movement, and more, sending real-time data to farmers’ devices. This helps in efficient resource use and quick action if something goes wrong.
 
  
    </p>
<div className='md:h-5 h-2'></div>
  </div>
</div>

    </div>
  );
};

export default GalleryPage1;
